import axios from "axios";
import {
  uploadTypeImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
} from "./utils/utils";
import { useSelector } from "react-redux";
import { newType,deleteType, saveAttributeToCatDoc } from "../../redux/actions/typeActions";
import { useDispatch } from "react-redux";

import CreateTypePageComponent from "./components/CreateTypePageComponent";

const createTypeApiRequest = async (formInputs) => {
  const { data } = await axios.post(`/api/types`, { ...formInputs });
  return data;
};

const AdminCreateTypePage = () => {
  const { types } = useSelector((state) => state.getTypes);
  const dispatch = useDispatch();

  return (
    <CreateTypePageComponent
      createTypeApiRequest={createTypeApiRequest}
      uploadTypeImagesApiRequest={uploadTypeImagesApiRequest}
      uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}
      types={types}
      reduxDispatch={dispatch}
      newType={newType}
      deleteType={deleteType}
      saveAttributeToCatDoc={saveAttributeToCatDoc}
    />
  );
};

export default AdminCreateTypePage;
